import React from 'react';

const PageFallback = () => (
  <div
    style={{
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0a0a0a',
      color: '#fff'
    }}
  >
    <div
      aria-label="Yükleniyor"
      style={{
        width: 48,
        height: 48,
        border: '4px solid rgba(74,21,32,0.25)',
        borderTopColor: '#5c1822',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}
    />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

export default PageFallback;
